import type { ReactNode } from 'react';
import type { ModuleKey } from '@nest-recruit/shared';
import { useModule } from '../lib/modules';

/**
 * Non-negotiable #13 (§L28, QoL §13): a piece of UI that belongs to a switchable module. When the
 * module is off it renders **nothing** — never a placeholder, a disabled control or an empty
 * box — so the flex and grid layouts around it close up.
 */
export function ModuleGate({ module, children }: { readonly module: ModuleKey; readonly children: ReactNode }): ReactNode {
  return useModule(module) ? children : null;
}
